import styled from 'styled-components'
import { StyledDetailWrapper } from '~/components/Exchange/styled'
import { NotificationLevel } from '~/components/NotificationBar'

const levelColors = {
  info: 'textBlack',
  warning: 'alertWarningText',
  risk: 'alertRiskText',
}

export const Container = styled(StyledDetailWrapper)`
  color: ${({ theme }) => theme.colors.textGrey2};
`

export const StyledLabel = styled.span`
  margin-right: 4px;
`

export const StyledValue = styled.span<{ level: NotificationLevel }>`
  color: ${({ level, theme }) => theme.colors[levelColors[level]]};
  font-weight: ${({ level }) => (level === 'info' ? 400 : 500)};
  letter-spacing: 0.2px;
`

export const StyledDiscountedBtn = styled.div`
  padding: 0px 4px;
  height: 16px;
  border-radius: 20px;
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
  background: linear-gradient(90deg, #ee8fce 8.33%, #d17ede 90.48%);
`
